// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const AssetSectionDeleteApiAssetsAssetIdSectionsKeyDeleteParams = zod.object({
  "revision": zod.int().min(1)
})

export type AssetSectionDeleteApiAssetsAssetIdSectionsKeyDeleteParams = zod.input<typeof AssetSectionDeleteApiAssetsAssetIdSectionsKeyDeleteParams>;
export type AssetSectionDeleteApiAssetsAssetIdSectionsKeyDeleteParamsOutput = zod.output<typeof AssetSectionDeleteApiAssetsAssetIdSectionsKeyDeleteParams>;
